export const TRACKER_TEMPLATE_QUERY_KEYS = {
  all: ['tracker-templates'] as const,
  listByWorkspace: (workspaceId: string) =>
    [...TRACKER_TEMPLATE_QUERY_KEYS.all, workspaceId] as const,
};
